export const CREATE_INVOICE = `
  mutation CreateInvoice($invoice: invoices_insert_input!) {
    insert_invoices_one(object: $invoice) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      contract_id
      job_id
      pricing_process_id
      invoice_name
      split_invoice
      custom_date_range
      date_range_start
      date_range_end
      invoice_code_ids
      payment_schedules
      total_unit_price
      invoice_code_id
      change_pricing_method
      new_pricing_type
      new_start_date
      created_at
    }
  }
`;

export const UPDATE_INVOICE = `
  mutation UpdateInvoice($id: Int!, $invoice: invoices_set_input!) {
    update_invoices_by_pk(pk_columns: { id: $id }, _set: $invoice) {
      id
      company_id
      firm_id
      firm_short_name
      firm_established
      contract_id
      job_id
      pricing_process_id
      invoice_name
      split_invoice
      custom_date_range
      date_range_start
      date_range_end
      invoice_code_ids
      payment_schedules
      total_unit_price
      invoice_code_id
      change_pricing_method
      new_pricing_type
      new_start_date
    }
  }
`;

export const DELETE_INVOICE = `
  mutation DeleteInvoice($id: Int!) {
    delete_invoices_by_pk(id: $id) {
      id
    }
  }
`;
